module.exports = __webpack_public_path__ + "img/icon-3.9ed4f20d.png";